import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpQuantityConverter
     * @memberof app
     *
     * @restrict A
     * @scope
     *
     * @description
     * This is for amount or capacity input fields.
     *
     * @attr {PkpUseOriginals} pkpUseOriginals
     * @attr {expression} pkpNoAddon
     *
     * @example
     * <input type="number" ng-model="model.quantity"
     *        pkp-quantity-converter="networkPoint.physicalUnit" pkp-use-originals>
     *
     * @author flzemke.btc
     */
    angular
        .module('app')
        .directive('pkpQuantityConverter', pkpQuantityConverter);

    function pkpQuantityConverter(
        $translate,
        bigDecimalConverterService,
        fieldKeyService
    ) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            var fieldKey = fieldKeyService.initialize(attr.pkpUseOriginals);

            /**
             * The physical unit that will be added to the model and the Bootstrap input addon.
             */
            var physicalUnit = scope.$eval(attr.pkpQuantityConverter);
            /**
             * The localized version of {@link physicalUnit}.
             *
             * @type {string}
             */
            var physicalUnitLocalized;
            /**
             * @type {string}
             */
            var jsonValueKey = fieldKey.valueKey;
            /**
             * @type {string}
             */
            var jsonUnitKey = fieldKey.unitKey;

            (function init() {
                ngModelCtrl.$parsers.push(convertToModelValue);
                ngModelCtrl.$formatters.push(convertToViewValue);

                localizePhysicalUnit().finally(function () {
                    appendInputAddon();
                });
            })();

            /**
             * Localize {@link physicalUnit} or, if no localization was found, keep the unlocalized string.
             *
             * @returns {$promise}
             */
            function localizePhysicalUnit() {
                return $translate('PhysicalUnit.' + physicalUnit)
                    .then(function (physicalUnitFromTranslateService) {
                        physicalUnitLocalized =
                            physicalUnitFromTranslateService.replace(
                                '&#179;',
                                '³'
                            );
                    })
                    .catch(function () {
                        physicalUnitLocalized =
                            physicalUnit === 'K_WH_D' ? 'kWh/d' : 'kWh/h';
                    });
            }

            /**
             * @param {number} viewValue
             * @returns {Object} value
             */
            function convertToModelValue(viewValue) {
                var bigDecimal = {};
                bigDecimal[bigDecimalConverterService.VALUE_KEY_NAME] =
                    !isNaN(viewValue) && viewValue !== null
                        ? viewValue.toString()
                        : '';
                bigDecimal[bigDecimalConverterService.FLAG_KEY_NAME] = true;

                var modelData = {};
                modelData[jsonValueKey] = bigDecimal;
                modelData[jsonUnitKey] =
                    physicalUnitLocalized ||
                    scope.$eval(attr.pkpQuantityConverter);
                return modelData;
            }

            /**
             * @param {number} modelValue
             * @returns {number|null} A number for the number input field, or null if it's empty.
             */
            function convertToViewValue(modelValue) {
                if (
                    !modelValue ||
                    !modelValue[jsonValueKey] ||
                    isNaN(modelValue[jsonValueKey].value)
                ) {
                    return null;
                }
                if (angular.isString(modelValue[jsonValueKey].value)) {
                    return parseInt(modelValue[jsonValueKey].value);
                }
                return modelValue[jsonValueKey].value.toNumber();
            }

            /**
             * Append the input field with a bootstrap input addon displaying
             * the localized physical unit {@link physicalUnitLocalized}.
             */
            function appendInputAddon() {
                if (scope.$eval(attr.pkpNoAddon) === true) {
                    return;
                }
                elem.after(
                    '<span class="input-group-addon">' +
                        physicalUnitLocalized +
                        '</span>'
                );
            }
        }
    }
})();
